// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__meWWF","errorLogs":"EditorFooter_errorLogs__3YQtl"};